import { Locales } from '../../context/Localization/localization.types';


export enum KeyboardLayouts {
    Alphanumeric = 'Alphanumeric',
    AlphanumericShift = 'AlphanumericShift',
    Password = 'Password',
    PasswordShift = 'PasswordShift',
    PasswordNumpad = 'PasswordNumpad',
    PasswordNumpadShift = 'PasswordNumpadShift',
    AlphanumericNumpad = 'AlphanumericNumpad',
    AlphanumericNumpadShift = 'AlphanumericNumpadShift',
    NumberPad = 'NumberPad',
    Price = 'Price',
    TelePad = 'TelePad',
    Email = 'Email',
    EmailShift = 'EmailShift',
    Symbols = 'Symbols',
    SymbolsNumpad = 'SymbolsNumpad'
}

const baseKeyboard = [
    '+ # & / - _ . \'',
    'q w e r t y u i o p',
    '{emptyHalfKey} a s d f g h j k l {emptyHalfKey}',
    '{shiftinactive} z x c v b n m {backspace} {emptyHalfKey}',
];
const baseShiftKeyboard = [
    '+ # & / - _ . \'',
    'Q W E R T Y U I O P',
    '{emptyHalfKey} A S D F G H J K L {emptyHalfKey}',
    '{shiftactive} Z X C V B N M {backspace} {emptyHalfKey}',
];
const basePasswordKeyboard = [
    '! @ # $ % " & * ( )',
    'q w e r t y u i o p',
    '{emptyHalfKey} a s d f g h j k l {emptyHalfKey}',
    '{shiftinactive} z x c v b n m {backspace} {emptyHalfKey}',
];
const basePasswordShiftKeyboard = [': ; , . - / + = < >', 'Q W E R T Y U I O P', 'A S D F G H J K L ?', '{shiftactive} Z X C V B N M {backspace} {emptyHalfKey}'];
const AlphanumericNumpadKeyboard = [
    '{empty} + # & / - _ . \' {empty} {boarderSpacer} 1 2 3',
    'q w e r t y u i o p {boarderSpacer} 4 5 6',
    '{emptyHalfKey} a s d f g h j k l {emptyHalfKey} {boarderSpacer} 7 8 9',
    '{shiftinactive} z x c v b n m {backspace} {emptyHalfKey} {boarderSpacer} {empty} 0 {empty}',
];
const AlphanumericNumpadShiftKeyboard = [
    '{empty} + # & / - _ . \' {empty} {boarderSpacer} 1 2 3',
    'Q W E R T Y U I O P {boarderSpacer} 4 5 6',
    '{emptyHalfKey} A S D F G H J K L {emptyHalfKey} {boarderSpacer} 7 8 9',
    '{shiftactive} Z X C V B N M {backspace} {emptyHalfKey} {boarderSpacer} {empty} 0 {empty}',
];
const PasswordNumpadKeyboard = [
    '! @ # $ % " & * ( ) {boarderSpacer} 1 2 3',
    'q w e r t y u i o p {boarderSpacer} 4 5 6',
    '{emptyHalfKey} a s d f g h j k l {emptyHalfKey} {boarderSpacer} 7 8 9',
    '{shiftinactive} z x c v b n m {backspace} {emptyHalfKey} {boarderSpacer} {empty} 0 {empty}',
];
const PasswordNumpadShiftKeyboard = [
    ': ; , . - / + = < > {boarderSpacer} 1 2 3',
    'Q W E R T Y U I O P {boarderSpacer} 4 5 6',
    'A S D F G H J K L ? {boarderSpacer} 7 8 9',
    '{shiftactive} Z X C V B N M {backspace} {emptyHalfKey} {boarderSpacer} {empty} 0 {empty}',
];
const numberPad = ['{numpad1} {numpad2} {numpad3}', '{numpad4} {numpad5} {numpad6}', '{numpad7} {numpad8} {numpad9}', '{empty} {numpad0} {backspace}'];
const price = ['{numpad1} {numpad2} {numpad3}', '{numpad4} {numpad5} {numpad6}', '{numpad7} {numpad8} {numpad9}', '. {numpad0} {bksp}'];
const commonEmailList = ['@', '{emailSpacer}', '@gmail.com', '{emailSpacer}', '@yahoo.com', '{emailSpacer}', '@hotmail.com', '{emailSpacer}', '.com'].join(' ');

// all languages use the same keyobard layout at the moment, but we could change this if needed
const genericLayouts = {
    [KeyboardLayouts.Alphanumeric]: [...baseKeyboard, '{numinactive} {empty} {empty} {space} {empty} {empty} {emptyWideKey} {emptyHalfKey}'],
    [KeyboardLayouts.AlphanumericShift]: [...baseShiftKeyboard, '{numinactive} {empty} {empty} {space} {empty} {empty} {emptyWideKey} {emptyHalfKey}'],
    [KeyboardLayouts.Password]: [...basePasswordKeyboard, '{numinactive} {symbols} {empty} {space} {empty} {empty} {emptyWideKey} {emptyHalfKey}'],
    [KeyboardLayouts.PasswordShift]: [...basePasswordShiftKeyboard, '{numinactive} {symbols} {empty} {space} {empty} {empty} {emptyWideKey} {emptyHalfKey}'],
    [KeyboardLayouts.AlphanumericNumpad]: [
        '{boarder}',
        ...AlphanumericNumpadKeyboard,
        '{numactive} {empty} {empty} {space} {empty} {empty} {empty} {empty} {boarderSpacer} {empty} {empty} {empty}',
    ],
    [KeyboardLayouts.AlphanumericNumpadShift]: [
        '{boarder}',
        ...AlphanumericNumpadShiftKeyboard,
        '{numactive} {empty} {empty} {space} {empty} {empty} {empty} {empty} {boarderSpacer} {empty} {empty} {empty}',
    ],
    [KeyboardLayouts.PasswordNumpad]: [
        '{boarder}',
        ...PasswordNumpadKeyboard,
        '{numactive} {symbols} {empty} {space} {empty} {empty} {empty} {empty} {boarderSpacer} {empty} {empty} {empty}',
    ],
    [KeyboardLayouts.PasswordNumpadShift]: [
        '{boarder}',
        ...PasswordNumpadShiftKeyboard,
        '{numactive} {symbols} {empty} {space} {empty} {empty} {empty} {empty} {boarderSpacer} {empty} {empty} {empty}',
    ],
    [KeyboardLayouts.Email]: [
        '{boarderEmail}',
        commonEmailList,
        ...AlphanumericNumpadKeyboard,
    ],
    [KeyboardLayouts.EmailShift]: [
        '{boarderEmail}',
        commonEmailList,
        ...AlphanumericNumpadShiftKeyboard,
    ],
    // Symbols keyboards are currently only used for tech password entry. Please consult PMD before using elsewhere.
    [KeyboardLayouts.Symbols]: [
        '! @ # $ % ^ & * {empty} {empty}',
        '~ ` { } [ ] ( ) {empty} {empty}',
        '; : \' " \\ | _ - {empty} {empty}',
        ', . / < > ? = + {backspace} {emptyHalfKey}',
        '{numinactive} {abc} {empty} {space} {empty} {empty} {emptyWideKey} {emptyHalfKey}',
    ],
    [KeyboardLayouts.SymbolsNumpad]: [
        '{boarder}',
        '! @ # $ % ^ & * {empty} {empty} {boarderSpacer} 1 2 3',
        '~ ` { } [ ] ( ) {empty} {empty} {boarderSpacer} 4 5 6',
        '; : \' " \\ | _ - {empty} {empty} {boarderSpacer} 7 8 9',
        ', . / < > ? = + {backspace} {emptyHalfKey} {boarderSpacer} {empty} 0 {empty}',
        '{numactive} {abc} {empty} {space} {empty} {empty} {empty} {empty} {boarderSpacer} {empty} {empty} {empty}',
    ],
    [KeyboardLayouts.NumberPad]: numberPad,
    [KeyboardLayouts.TelePad]: numberPad,
    [KeyboardLayouts.Price]: price,
};

export const SimpleKeyboardLayouts: Record<Exclude<Locales, Locales.none>, Record<KeyboardLayouts, string[]>> = {
    [Locales.en]: genericLayouts,
    [Locales.es]: genericLayouts,
    [Locales.fr]: genericLayouts,
};
